import { useState } from "react";

function todayLocal() {
    const now = new Date();
    const offset = now.getTimezoneOffset() * 60_000;
    return new Date(now.getTime() - offset).toISOString().slice(0, 10);
}

export default function EmployeeTerminationModal({ employee, loading = false, onCancel, onConfirm }) {
    const [dateFired, setDateFired] = useState(todayLocal());
    const [reason, setReason] = useState("");
    const cleanReason = reason.trim();

    const submit = (event) => {
        event.preventDefault();
        if (!dateFired || cleanReason.length < 3 || loading) return;
        onConfirm({ date_fired: dateFired, reason: cleanReason });
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4 backdrop-blur-sm" data-testid="employee-termination-modal">
            <form onSubmit={submit} className="w-full max-w-lg space-y-4 rounded-2xl bg-white p-6 shadow-2xl">
                <div>
                    <h2 className="text-xl font-semibold text-slate-900">Оформить увольнение</h2>
                    <p className="mt-1 text-sm text-slate-500">
                        {employee.full_name}. Карточка и история сохранятся, активные процессы будут завершены.
                    </p>
                </div>
                <label className="block text-sm font-medium text-slate-700">
                    Дата увольнения
                    <input
                        type="date"
                        required
                        min={employee.date_hired || undefined}
                        max={todayLocal()}
                        value={dateFired}
                        onChange={(event) => setDateFired(event.target.value)}
                        className="mt-1 block w-full rounded-xl border border-slate-200 px-3 py-2"
                        data-testid="termination-date"
                    />
                </label>
                <label className="block text-sm font-medium text-slate-700">
                    Причина увольнения
                    <textarea
                        required
                        minLength={3}
                        maxLength={2000}
                        rows={4}
                        value={reason}
                        onChange={(event) => setReason(event.target.value)}
                        placeholder="Укажите причину — она будет сохранена в истории сотрудника"
                        className="mt-1 block w-full resize-y rounded-xl border border-slate-200 px-3 py-2"
                        data-testid="termination-reason"
                    />
                </label>
                <p className="rounded-xl bg-amber-50 px-3 py-2 text-xs text-amber-800">
                    Увольнение остановит активную адаптацию, закроет ВНР и освободит место заявки. Физического удаления данных не будет.
                </p>
                <div className="flex justify-end gap-2">
                    <button type="button" onClick={onCancel} disabled={loading} className="rounded-xl px-4 py-2 text-sm text-slate-600 hover:bg-slate-50">
                        Отмена
                    </button>
                    <button
                        type="submit"
                        disabled={loading || !dateFired || cleanReason.length < 3}
                        className="rounded-xl bg-red-600 px-4 py-2 text-sm font-medium text-white disabled:cursor-not-allowed disabled:opacity-50"
                        data-testid="termination-submit"
                    >
                        {loading ? "Сохранение…" : "Подтвердить увольнение"}
                    </button>
                </div>
            </form>
        </div>
    );
}
